import React from 'react';
import { Routes, Route } from "react-router-dom";
import Solidcolorwrapper from '../pages/Solid';
import Gradientcolorcomponent from '../pages/Gradient';
import Imagepicker from '../pages/Image-picker';
import Explorer from '../pages/Explorer/Explorer';
import Modulewrapper from "../layouts/Module-wrapper";

export default function AppRoutes() {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <Modulewrapper>
                        <Solidcolorwrapper />
                    </Modulewrapper>}
            />
            <Route
                path="/gradient"
                element={
                    <Modulewrapper>
                        <Gradientcolorcomponent />
                    </Modulewrapper>
                }
            />

            <Route
                path="/color_extractor"
                element={
                    <Modulewrapper>
                        <Imagepicker />
                    </Modulewrapper>
                }
            />
            <Route
                path="/explorer"
                element={
                    <Modulewrapper>
                        <Explorer />
                    </Modulewrapper>
                }
            />
        </Routes >
    )
}
